/**
 * Thrown by OperatorService.fetchByCallsign when no operator record matches the
 * callsign in any consulted source (local DB, bundled static data, and -- when
 * permitted -- the API). A dedicated type lets callers distinguish a genuine
 * miss from an unexpected backend failure without matching on the error message.
 */
export class OperatorNotFoundError extends Error {
  constructor(callsign: string) {
    super(`Operator ${callsign} not found`);
    this.name = "OperatorNotFoundError";
  }
}
